"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeteleContactModal = DeteleContactModal;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _BasicConfirmDialog = _interopRequireDefault(require("../BasicConfirmDialog"));

function DeteleContactTitle() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold mb-2"
  }, t('contact.action.delete.title'));
}

function DeleteContactBody() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, " ", t('contact.action.delete.body'));
}

function DeteleContactModal(props) {
  return /*#__PURE__*/_react["default"].createElement(_BasicConfirmDialog["default"], (0, _extends2["default"])({
    confirmTexti18nKey: "button.delete"
  }, props), /*#__PURE__*/_react["default"].createElement(DeteleContactTitle, null), /*#__PURE__*/_react["default"].createElement(DeleteContactBody, null));
}
//# sourceMappingURL=DeteleContactModal.js.map